<template>
  <v-app id="decidedly">
    <v-main class="login-container">
      <v-container
        fluid
      >
        <v-row align="center" justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
            class="pt-6"
          >

            <v-card>
              <v-card-title class="d-flex align-center justify-center">
                  <div>
                    <router-link to="/">
                    <v-img
                      alt="Decidedly Logo"
                      :src="require('../assets/logo-blue.svg')"
                      max-width="55"
                    ></v-img>
                    </router-link>
                  </div>
                  <div class="ml-2">
                    <div class="logo-title">
                      Decidedly is moving
                    </div>
                  </div>
              </v-card-title>
              <v-card-text class="text-center subtitle-1">
                <p>Decidedly Alpha is wrapping up and moving to a different domain.</p>

                <p>This site will start redirecting to a new home soon.</p>

                <p>Thanks for helping us during our Alpha program.</p>

              </v-card-text>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'moving'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login-container {
  background: #0e2887;
  /*background-image: url("IMAGE_URL"); fallback */
  background: linear-gradient(#3a52b5, #0e2887); /* W3C */
  /*background-image: linear-gradient(#3a52b5, #0e2887);*/
  color: white;
}
.comparison-list {
  display: flex;
  justify-content: space-around;
}
.logo-title {
  color: #1e40aa;
  text-transform: uppercase;
}
</style>
